import React from 'react'
import SocialFasho from '../../assets/Images/fashionBG.svg';
const ProfileSlideCard = ({item,modalToggle, userId}) => {
    return (
        <>
            <div className="bg-transparent h-full cursor-pointer rounded-full" onClick={modalToggle}>
                <img className="relative rounded-lg flex h-full w-full object-cover " src={`https://polar-castle-07148.herokuapp.com/api/user/images/wardrobe/${userId}/${item.itemUrl}`}/>
            </div>
        </>
    )
}

export default ProfileSlideCard